import { render, staticRenderFns } from "./TelaDeRelatoriosDeDocumentosFiscais.vue?vue&type=template&id=4fc67936&"
import script from "./TelaDeRelatoriosDeDocumentosFiscais.vue?vue&type=script&lang=ts&"
export * from "./TelaDeRelatoriosDeDocumentosFiscais.vue?vue&type=script&lang=ts&"
import style0 from "./TelaDeRelatoriosDeDocumentosFiscais.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCol,VContainer,VForm,VIcon,VRow,VTooltip})
